module.exports = __webpack_public_path__ + "static/media/deezer.becfdd4a.svg";